import React from "react";
import styled from "styled-components";

export default styled.div`
    position: absolute;
    width: 100%;
    ${({position}) => {
        switch (position) {
            case "top":
                return {
                    'top': '0px'
                };
            case "middle":
                return {
                    'transform': 'translateY(-50%)',
                    'top': '50%'
                };
            case "bottom":
                return {
                    'bottom': '20px'
                };
        }
    }};
    
    @media(max-height: 575px) {
        
        ${({position}) => {
            switch (position) {
                case "top":
                    return {
                        'position': 'relative',
                        'top': '0',
                        'bottom': '0',
                        'left': '0',
                        'right': '0',
                        'transform': 'translate(0)',
                    };
                case "middle":
                    return {
                        'position': 'relative',
                        'top': '0',
                        'bottom': '0',
                        'left': '0',
                        'right': '0',
                        'transform': 'translate(0)',
                    };
            }
        }};
    }
`;

